(window as any).git_hash = "0933f4adffa3971a732682747d2bafe095730162"